module.exports = __webpack_public_path__ + "static/media/VorbereitungBH02.7cef2be6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/VorbereitungBH02.jpg
// module id = 343
// module chunks = 0